import { ContactScreen } from 'app/features/contact/screen'
import { GetServerSideProps } from 'next'
import { withAuthedPage } from '../../lib/session'

export default ContactScreen

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async () => {
    return {
      props: {},
    }
  },
)
